export function useErroControlManul() {
  const useArrayErrorForm = (array, setError) => {
    if (array) {
      Object.entries(array).map(([key, item]) => {
        setError(key, { type: 'manual', message: item });
      });
    }
  };
  return { useArrayErrorForm };
}
